import * as React from "react";

function SvgLockWithKeyHole(props) {
  return <svg fill="currentColor" viewBox="0 0 24 24" width={24} height={24} {...props}><path fill="currentColor" d="M12 18a2 2 0 100-4 2 2 0 000 4zm6-9a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V11a2 2 0 012-2h1V7a5 5 0 1110 0v2h1zm-6-5a3 3 0 00-3 3v2h6V7a3 3 0 00-3-3z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/lockWithKeyHole_6fc863.svg";
export { SvgLockWithKeyHole as ReactComponent };